export enum ETrackingOrdersStatus {
    'STATUS_UNKNOWN' = 'Unknown',
    'STATUS_ALERT' = 'Alert',
    'STATUS_DELIVERED' = 'Delivered',
    'STATUS_INTRANSIT' = 'Intransit',
    'STATUS_UNDELIVERED' = 'Undelivered',
    'STATUS_NOTFOUND' = 'Not Found',
}

export interface ITrackingOrder {
    id: number;
    order_name: string;
    order_id: number;
    shop_id: any;
    started_at: string | null;
    status: ETrackingOrdersStatus;
    supplier_id: number;
    supplier_name: string;
    tracking_info: string;
    tracking_number: string;
    latest_updated_at: string | null;
    non_updated_count: number;
}
